import { Protocol } from './_types';

export const LIB_PROTOCOL_POMEGRANATE_HARVEST_SCREEN_EVAL: Protocol = {
    id: "pomegranate_harvest_screen_eval",
    title: "Advanced Pomegranate Harvest Evaluation",
    description: "Harvest evaluation is performed to characterise new cultivars and selections on the base of their fruit traits. Visual and sensory fruit evaluation are applied to describe fruit quality and keeping ability after storage over a specified storage period. Characteristics such as colour and pattern, shapes and symmetry, defects and disorders and eating quality are evaluated in detail.",
    sampleType: "harvest",

    chars: [
        // RIPENING
        "frut_peel_hardness",
        "frut_peel_hard_consist",

        // APPERANCE
        "frut_peel_gloss",
        "frut_skin_texture",
        "frut_peel_color_uni",

        // SHAPE & SYMMETRY
        "frut_shape_type_pomegranate",

        // ADHESION
        "frut_calyx_adhesion",
        "frut_aril_adhesion_mem",
        "frut_mem_adhesion_peel",
        "frut_aril_skin_integ",

        // COLOUR AND PATTERN
        "frut_aril_color_int",

        // SIZE
        "frut_aril_size",
        "frut_edible_portion",

        // POST HARV DEFECTS
        "frut_external_defects",

        // POST HARV PESTS
        "frut_postharv_pest_ident",

        // TASTE
        "frut_sweet_taste",
        "frut_acid_taste",
        "frut_bitter_taste",
        "frut_sugar_acid_taste",
        "frut_astringency_taste",
        "frut_off_taste",

        // MOUTHFEEL
        "frut_firm_feel",
        "frut_juice_feel",
        "frut_seed_crunch_feel",

        // AROMA
        "frut_aroma",
        "frut_unpleasant_aroma",
    ],

    measures: [
        // FRUIT
        "frut_length",
        "frut_diameter",
        "frut_weight",
        "frut_thickness",
        "frut_tss",
        "frut_acid",
        "frut_acid_citric",
        "frut_acid_tart",
        "frut_pomasa",
        "frut_cielab_l",
        "frut_cielab_a",
        "frut_cielab_b",

        // PATHOLOGY
        "frut_pathology_alter",
        "frut_pathology_asper",
        "frut_pathology_peni",
        "frut_pathology_bot",
        "frut_pathology_rhi",
        "frut_pathology_collet",
        "frut_pathology_clado",
        "frut_pathology_cera",
        "frut_pathology_phomo",
        "frut_pathology_gene",

        // PHYSIOLOGY
        "frut_physiology_chill",
        "frut_physiology_wei_l",
        "frut_physiology_int_b",
        "frut_physiology_sun",
        "frut_physiology_crack",
        "frut_physiology_rind",
    ],

    calculations: [
        "sugar_acid_ratio_calc"
    ],

    indexes: [

    ],
}